"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { useAui, AuiProvider } from "@assistant-ui/store";
import { RuntimeAdapter } from "./RuntimeAdapter.js";
import { ThreadPrimitiveViewportProvider } from "../context/providers/ThreadViewportProvider.js";
import { DevToolsProviderApi } from "../devtools/index.js";
const getRenderComponent = (runtime) => {
    return runtime._core?.RenderComponent;
};
export const AssistantRuntimeProviderImpl = ({ children, aui: parent = null, runtime }) => {
    const aui = useAui({ threads: RuntimeAdapter(runtime) }, { parent: parent });
    useEffect(() => {
        if (typeof process === "undefined" ||
            process.env["NODE_ENV"] === "production")
            return;
        return DevToolsProviderApi.register(aui);
    }, [aui]);
    const RenderComponent = getRenderComponent(runtime);
    return (_jsxs(AuiProvider, { value: aui, children: [RenderComponent && _jsx(RenderComponent, {}), _jsx(ThreadPrimitiveViewportProvider, { children: children })] }));
};
export const AssistantRuntimeProvider = memo(AssistantRuntimeProviderImpl);
//# sourceMappingURL=AssistantRuntimeProvider.js.map